import React from 'react';

const PrinterBody = () => {
  return (
    <div>

    </div>
  );
};

export default PrinterBody;
